import { authorizedGetCall } from "./APIsService";

export const getCreatedActivities = (id) => {
  return new Promise((resolve, reject) => {
    authorizedGetCall(`activities-created/${id}`)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getJoinedActivities = (id) => {
  return new Promise((resolve, reject) => {
    authorizedGetCall(`activities-joined/${id}`)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getActivityMessages = (userId, _id) => {
  return new Promise((resolve, reject) => {
    authorizedGetCall(`activity-messages/${_id}?userId=${userId}`)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getActivityData = (activityId) => {
  return new Promise((resolve, reject) => {
    authorizedGetCall(`activity-data/${activityId}`)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
